export const getHoverTooltipMaxWidth = (
  size: 'extra-small' | 'small' | 'regular',
) => {
  if (size === 'extra-small') {
    return '190px';
  }
  if (size === 'small') {
    return '240px';
  }
  return '320px';
};
